import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useMeasure } from '@uidotdev/usehooks'

import YearPicker from '../../../../components/YearPicker/YearPicker'
import getDateForYear from '../../../../utils/get_date_for_year'
import { type Emissions, type EmissionsFilters } from '../../../../types/data'
import { CLASS_NAME } from './const'

import './style.scss'

type Props = {
  minDate?: Date | null
  maxDate?: Date | null
  filters: EmissionsFilters
  emissions: Emissions[] | null
  emissionsMaxDate?: Date | null
  emissionsMinDate?: Date | null
  setFilterValue: (key: string, value: any) => void
}

export default function SelectYears({
  minDate,
  maxDate,
  filters,
  setFilterValue
}: Props) {
  const { t } = useTranslation()
  const [ref] = useMeasure()
  const currentYear = new Date().getUTCFullYear()
  const { start, end } = filters
  const endYear = end === null ? currentYear : end.getUTCFullYear()
  const startYear = start === null ? currentYear - 5 : start.getUTCFullYear()

  const handleSetStartYear = useCallback(
    (year: number): void => {
      setFilterValue('start', getDateForYear(year))
    },
    [setFilterValue]
  )

  const handleSetEndYear = useCallback(
    (year: number): void => {
      setFilterValue('end', getDateForYear(year, 11))
    },
    [setFilterValue]
  )

  return (
    <div ref={ref} className={CLASS_NAME}>
      {minDate !== null && (
        <YearPicker
          value={startYear}
          minDate={minDate}
          maxDate={new Date(`${endYear - 1}`)}
          onChange={handleSetStartYear}
          label={t('analytics_controls.start_year_picker_label')}
        />
      )}
      <YearPicker
        value={endYear}
        maxDate={maxDate ?? undefined}
        minDate={new Date(`${startYear + 1}`)}
        onChange={handleSetEndYear}
        label={t('analytics_controls.end_year_picker_label')}
      />
    </div>
  )
}

export { CLASS_NAME }
